export default __webpack_public_path__ + "static/media/cont_item_13_2022_en_4.546fac6c.png";